
import $ from 'jquery';

const ajaxrequest_per_iframe_custom = (input, item2type) => {
    if ($('#iframe_for_ajax').html() == undefined) {
        const iframe = document.createElement('iframe');
        iframe.id = 'iframe_for_ajax';
        iframe.style.display = "none";
        document.body.appendChild(iframe);
    }
    if ($('#iframe_for_ajax').html() != undefined) {
        const warenkorb_ajax_src = $('#iframe_for_header').attr('src') + item2type;
        $('#iframe_for_ajax').attr('src', input + "&redirecturl=" + encodeURIComponent(warenkorb_ajax_src));
    }
}

const addToBasketPerAjax = () => {
    let param = "";
    $('#articletobasketform input[type=hidden]').each(function (index, data) {
        param += "&" + $(this).attr("name") + "=" + $(this).val();
    });
    ajaxrequest_per_iframe_custom($('#articletobasketform').attr('action') + param, "&item2basket=1");
}

const addToNoticeListPerAjax = () => {
    ajaxrequest_per_iframe_custom($('#linkToNoticeList').attr('action') + param, "&item2wishlist=1");
}

// Add to Basket per ajax.
$(document).on('click', '.acl_js_ajax_add_to_basket', function (evt) {
    ev.preventDefault();
    addToBasketPerAjax();
});

$(document).on('click', '#linkToNoticeList', function(evt) {
    evt.preventDefault();
    addToNoticeListPerAjax();
});

window.addToBasketPerAjax = addToBasketPerAjax;
window.addToNoticeListPerAjax = addToNoticeListPerAjax;

export {
    addToBasketPerAjax,
    addToNoticeListPerAjax
}
